var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEns(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 48,
    viewBox: "0 0 44 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.53598 19.4321C6.01246 20.4472 7.1933 22.4567 7.1933 22.4567L20.7626 0.020752L7.50404 9.26029C6.71682 9.7782 6.07461 10.5033 5.61885 11.3319C4.39658 13.8801 4.37586 16.8425 5.53598 19.4321Z",
    fill: "url(#paint0_linear_93_567)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.148778 26.8071C0.459524 31.1575 2.61403 35.1558 6.07368 37.7868L20.7202 48C20.7202 48 11.5635 34.7829 3.81559 21.6487C3.02836 20.2607 2.51045 18.7484 2.26186 17.1739C2.15827 16.4696 2.15827 15.7445 2.26186 15.0194C2.05469 15.3923 1.66108 16.1588 1.66108 16.1588C0.873853 17.754 0.335226 19.4734 0.0866286 21.2343C-0.0376701 23.0781 -0.0376702 24.9633 0.148778 26.8071Z",
    fill: "#A0A8D4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5196 28.5887C37.0431 27.5736 35.8622 25.5641 35.8622 25.5641L22.293 48L35.5308 38.7605C36.318 38.2426 36.9602 37.5175 37.416 36.6888C38.659 34.12 38.6797 31.1575 37.5196 28.5887Z",
    fill: "url(#paint1_linear_93_567)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9074 21.1929C42.5966 16.8425 40.4421 12.8442 36.9825 10.2132L22.3359 0C22.3359 0 31.4926 13.2171 39.2406 26.3513C40.0278 27.7393 40.5457 29.2516 40.7943 30.8261C40.8979 31.5304 40.8979 32.2555 40.7943 32.9806C41.0015 32.6077 41.3951 31.8412 41.3951 31.8412C42.1823 30.246 42.7209 28.5265 42.9695 26.7656C43.0938 24.9219 43.0938 23.0574 42.9074 21.1929Z",
    fill: "#A0A8D4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.61792 11.3319C6.07368 10.5033 6.71589 9.7782 7.50312 9.26029L20.7409 0.020752L7.17165 22.4567C7.17165 22.4567 5.99082 20.4472 5.51434 19.4321C4.35422 16.8425 4.39565 13.8801 5.61792 11.3319ZM0.148778 26.8071C0.459524 31.1576 2.61403 35.1558 6.07368 37.7868L20.7202 48C20.7202 48 11.5635 34.7829 3.81559 21.6487C3.02836 20.2607 2.51045 18.7484 2.26186 17.174C2.15827 16.4696 2.15827 15.7445 2.26186 15.0195C2.05469 15.3924 1.66108 16.1589 1.66108 16.1589C0.873853 17.754 0.335226 19.4735 0.0866286 21.2344C-0.0376701 23.0782 -0.0376702 24.9634 0.148778 26.8071ZM37.5005 28.5887C37.0241 27.5736 35.8432 25.5641 35.8432 25.5641L22.2947 48L35.5325 38.7605C36.3197 38.2426 36.9619 37.5175 37.4177 36.6889C38.6399 34.1407 38.6814 31.1783 37.5005 28.5887V28.5887ZM42.8868 21.2137C42.5761 16.8632 40.4216 12.8649 36.9619 10.234L22.3361 0.020752C22.3361 0.020752 31.4928 13.2378 39.2407 26.3721C40.0279 27.7601 40.5458 29.2724 40.7944 30.8468C40.898 31.5512 40.898 32.2763 40.7944 33.0013C41.0016 32.6284 41.3952 31.8619 41.3952 31.8619C42.1825 30.2668 42.7211 28.5473 42.9697 26.7864C43.1147 24.9219 43.1147 23.0574 42.9282 21.193L42.8868 21.2137Z",
    fill: "url(#paint2_linear_93_567)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_93_567",
    x1: 21.3402,
    y1: 0.555588,
    x2: 3.92151,
    y2: 19.4387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#A0A8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#8791C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#6470B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_93_567",
    x1: 21.7126,
    y1: 47.4536,
    x2: 39.1339,
    y2: 28.5741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#A0A8D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#8791C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#6470B4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_93_567",
    x1: 21.5257,
    y1: -0.227203,
    x2: 21.5257,
    y2: 48.1487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#513EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#5157FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#5298FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52E5FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEns);
export default __webpack_public_path__ + "static/media/ens.e85a59c7.svg";
export { ForwardRef as ReactComponent };